import constants from "constants/constants";
import moment from "moment";

export const bootstrap_width = {
  sm: 3,
  md: 4,
  large: 6,
  xl: 12,
};

export const chart_description = [
  "",
  "Total amount earned from an offering",
  "Total bookings/purchases of an offering",
  "Total unique visitors on offering page",
  "Total leads of an offering",
];

export const monthDays = parseInt(moment().format("DD"));
export const max_range_days = 90;

export const month_count = 1;

export const empty_chart_value = "empty";

export const filter_dropdown_options = [
  {
    id: constants.dashboardFilter.last7days,
    label: "Last 7 days",
    value: constants.dashboardFilter.last7days,
  },
  {
    id: constants.dashboardFilter.last30days,
    label: "Last 30 days",
    value: constants.dashboardFilter.last30days,
  },
  { id: monthDays, label: "This month", value: monthDays },
  {
    id: constants.dashboardFilter.lastMonthValue,
    label: "Last month",
    value: constants.dashboardFilter.lastMonthValue,
  },
  {
    id: constants.dashboardFilter.allTime,
    label: "All time",
    value: constants.dashboardFilter.allTime,
  },
  {
    id: constants.dashboardFilter.custom,
    label: "Custom",
    value: constants.dashboardFilter.custom,
  },
];

export const tracker_tabs = {
  bookings: { title: "Bookings", value: 2 },
  views: { title: "Views", value: 3 },
  leads: { title: "Leads", value: 4 },
  revenue: { title: "Revenue", value: 1 },
};

export const hidden_card_count = {
  xl: 3,
  large: 2,
  md: 1,
};
export const min_count = 0;

export const chart_size_value = {
  min: 0,
  max: 5,
};

export const graph_title_text = {
  line: "Daily Tracker",
  bar: "Offering Performance",
};

export const chart_refer = ["", "Revenue", "Bookings", "Views", "Leads"];

export const manage_your_webpage_cta_label = "Manage your Webpage";

export const chart_primary_cta_labels = [
  "",
  "Manage your Revenue",
  "Manage your Bookings",
  "Share your offering",
  "Manage your Leads",
];

export const lead_chart_refer = {
  leads: "count",
  converted: "count",
  interested: "count",
  amount: "sum",
};

export const common_dashboard_filters = {
  page_views: true,
  bookings: true,
  earnings: true,
  leads: true,
};

export const default_static_banner_height = 400;

export const SUBSCRIPTION_STATS_KEYS = {
  renewedSubscription: "total_subscription_renewals",
  renewalDueSoon: "due_soon_count",
  renewalOverDue: "over_due_count",
  renewalSuccessRate: "renewal_success_rate",
};

/** Card config for subscription stats (Renewal Details). Values are filled in the reducer from API response. */
export const SUBSCRIPTION_STATS_CARD_CONFIG = [
  {
    color: "#E5FFF7",
    title: "Renewed Subscription",
    value: "",
    title_color: "#00B77A",
    tooltip: "Clients who have renewed / purchased subscriptions",
    key: SUBSCRIPTION_STATS_KEYS.renewedSubscription,
    filter: { renewal_segment: "renewed_subscription" },
  },
  {
    color: "rgba(255, 171, 0, 0.1)",
    title: "Renewal Due Soon",
    value: "",
    title_color: "rgba(255, 171, 0, 1)",
    tooltip:
      "Clients who have purchased a subscription / recurring listing for whom the renewal needs to happen within 3 days",
    key: SUBSCRIPTION_STATS_KEYS.renewalDueSoon,
    filter: { renewal_segment: "renewal_due" },
  },
  {
    color: "rgba(191, 38, 0, 0.1)",
    title: "Renewal Over Due ",
    value: "",
    title_color: "rgba(191, 38, 0, 1)",
    tooltip:
      "Clients who have purchased a subscription / recurring listing who did not renew even after the due date",
    key: SUBSCRIPTION_STATS_KEYS.renewalOverDue,
    filter: { renewal_segment: "renewal_overdue" },
  },
  {
    color: "#EEECF9",
    title: "Renewal Success Rate",
    value: "",
    title_color: "#4A3AB1",
    tooltip:
      "% of clients who have renewed a subscription / recurring listing out of all who initially purchased it",
    key: SUBSCRIPTION_STATS_KEYS.renewalSuccessRate,
  },
];
